module.exports = __webpack_public_path__ + "img/34_32.f33e0bca.png";